export const text = {
  SUMMARY: 'Summary',
  VISIT_COST: 'Visit cost (USD)*',
  VISIT_CREDIT: 'Visit credit',
  TOTAL: 'Total',
}

export const styles = {
  PRICE_INPUT_CONTAINER: { width: '100%' },
}
